const e=async(e,t,n)=>{let{data:r}=await e.post(`/apps/${t}/terms/${n}/publish`);return r};export{e as publishTerms};
//# sourceMappingURL=publish-terms.mjs.map